import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { networkData } from '@/core/utils/networks';

interface Network {
	id: number;
	name: string;
	image?: string;
}

interface NetworkState {
	networkSelected: Network;
	networks: Network[];
}

const networkSlice = createSlice({
	name: 'network',
	initialState: {
		networkSelected: {},
		networks: networkData,
	} as NetworkState,
	reducers: {
		setNetworkSelected: (state, action: PayloadAction<Network>) => {
			state.networkSelected = action.payload;
		},
	},
});

const { reducer, actions } = networkSlice;

export const { setNetworkSelected } = actions;
export default reducer;
